import React from "react";
import { Box, Typography, Button } from "@mui/material";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import { darkTheme } from "../../theme/Theme";
import { useSelector } from "react-redux";
import useThemeRender from "../../theme/useThemeRender";

const InfoBlock = ({ title, value, isDarktheme, darkTheme }) => (
  <Box
    sx={{
      display: "flex",
      padding: "4px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "2px",
      alignSelf: "stretch",
      borderRadius: "8px",
      background: isDarktheme
        ? darkTheme.insideCardBackgroundColorLayer2
        : "var(--Tokens-Background-Layer-02, #EFF5FC)",
    }}
  >
    <Typography
      sx={{
        color: isDarktheme
          ? darkTheme.textColorLayer2
          : "var(--Tokens-Text-Secondary, #616161)",
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: "20px",
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        color: isDarktheme
          ? darkTheme.textColorLayer1
          : "var(--Tokens-Text-Secondary, #616161)",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
      }}
    >
      {value || "-"}
    </Typography>
  </Box>
);

export default function SubjectMatterCards({ data }) {
  const isDarktheme = useSelector((state) => state.theme);

  const handleClick = (url) => {
    if (url) window.open(url, "_blank");
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: { xs: "100%", md: "299px" },
        padding: "24px",
        flexDirection: "column",
        gap: "16px",
        borderRadius: "8px",
        backgroundColor: isDarktheme
          ? darkTheme.insideCardBackgroundColorLayer1
          : "#FFF",
        boxShadow: `0px 2px 24px 8px ${useThemeRender("boxShadowlayerColor1")}`,
      }}
    >
      <Typography
        sx={{
          color: useThemeRender("textColorLayer2"),
          fontSize: "16px",
          fontWeight: 700,
          lineHeight: "22px",
        }}
      >
        {data?.name}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          padding: "8px",
          background: isDarktheme
            ? darkTheme.insideCardBackgroundColorLayer2
            : "#F3F7FD",
          alignSelf: "stretch",
        }}
      >
        <InfoBlock
          title="Organization"
          value={data?.organization}
          isDarktheme={isDarktheme}
          darkTheme={darkTheme}
        />
        <InfoBlock
          title="Expertise"
          value={data?.role}
          isDarktheme={isDarktheme}
          darkTheme={darkTheme}
        />
        <InfoBlock
          title="Email"
          value={data?.email}
          isDarktheme={isDarktheme}
          darkTheme={darkTheme}
        />
        <InfoBlock
          title="Phone Number"
          value={data?.phone}
          isDarktheme={isDarktheme}
          darkTheme={darkTheme}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          alignSelf: "stretch",
        }}
      >
        <Button
          sx={{
            display: "flex",
            height: "32px",
            gap: "4px",
            textTransform: "none",
          }}
          disabled={!data?.linkedinLink}
          onClick={() => handleClick(data?.linkedinLink)}
        >
          <Typography
            sx={{
              color: !data?.linkedinLink ? "gray" : "#005CBC",
              fontSize: "14px",
              fontWeight: 700,
              lineHeight: "20px",
            }}
          >
            View on Linkedin
          </Typography>
          <LaunchOutlinedIcon
            sx={{
              fill: !data?.linkedinLink ? "gray" : "#005CBC",
              width: "20px",
              height: "20px",
            }}
          />
        </Button>
      </Box>
    </Box>
  );
}
